<template>
    <div class="subdomain-topnav">
        <div
            class="subdomain-topnav__item subdomain-topnav__item--info"
            @click="$router.push({ name: RoutesEnum.SUBDOMAIN.COMPANY })"
        >
            <div class="app-topnav__mobile-nav" @click.stop="emitEvent({ name: 'open-sidenav' })">
                <common-icon name="mobile-nav" size="extra-huge"></common-icon>
            </div>
            <img :src="companyAvatar" :alt="$t('alt.company_avatar')" />
            <p v-if="!isSmartphoneLarge">{{ companyName }}</p>
        </div>
        <div v-if="!isTablet" class="subdomain-topnav__item subdomain-topnav__item--routes">
            <subdomain-menu-item
                v-for="item in menuItems.filter((el) => el.isVisible)"
                :key="item.label"
                :route="item"
            ></subdomain-menu-item>
        </div>
        <div class="subdomain-topnav__item">
            <div class="app-topnav__user-menu">
                <locale-select></locale-select>
                <app-user-menu v-if="isUserLoggedIn"></app-user-menu>
                <common-button
                    v-else
                    type="primary"
                    :label="$t('layouts.app.top_menu.login')"
                    :route="{ name: RoutesEnum.AUTH.LOGIN }"
                    :size="buttonSize"
                ></common-button>
            </div>
        </div>
    </div>
</template>

<script>
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    import Store from '~/store'
    import RoutesEnum from 'enums/routes.enum'
    import ReservationTypeEnum from 'enums/reservation_type.enum'
    import { isRouteNameEqual, matchFullRoute } from '~/helpers'
    import SubdomainMenuItem from './SubdomainMenuItem.vue'
    import LocaleSelect from 'components/page-elements/localization/LocaleSelect'
    import AppUserMenu from 'components/layouts/components/main-layout/AppUserMenu'

    export default {
        mixins: [WindowResizeMixin],

        components: { SubdomainMenuItem, LocaleSelect, AppUserMenu },

        data() {
            return {
                placeholderImage: require('../../../../assets/images/user-placeholder.png'),
                RoutesEnum,
            }
        },

        computed: {
            itemClass() {
                return {
                    'subdomain-topnav__item--routes_item': true,
                    'subdomain-topnav__item--routes_item--is-current': this.route
                        ? this.route.matchFullRoute
                            ? matchFullRoute(this.route, this.$route)
                            : isRouteNameEqual(this.route.name, this.$route.name)
                        : false,
                }
            },

            buttonSize() {
                return this.isSmartphoneLarge ? 'small' : 'medium-small'
            },

            isUserLoggedIn() {
                return this.$auth.isLoggedIn()
            },

            companyName() {
                return Store.getters['data/getSubdomainCompany'].name
            },

            companyAvatar() {
                return Store.getters['data/getSubdomainCompany'].photoAvatar || this.placeholderImage
            },

            menuItems() {
                return [
                    {
                        route: { name: RoutesEnum.SUBDOMAIN.COMPANY },
                        label: this.$t('layouts.app.main_menu.home'),
                        isVisible: true,
                    },
                    {
                        route: { name: RoutesEnum.SUBDOMAIN.OFFER },
                        label: this.$t('layouts.app.main_menu.offers'),
                        isVisible: true,
                    },
                    {
                        route: {
                            name: RoutesEnum.SUBDOMAIN.RESERVATIONS,
                            params: { type: ReservationTypeEnum.MADE },
                            matchFullRoute: true,
                        },
                        label: this.$t('layouts.app.main_menu.reservations'),
                        isVisible: this.isUserLoggedIn,
                    },
                    {
                        route: { name: RoutesEnum.SUBDOMAIN.CONTACT },
                        label: this.$t('layouts.app.main_menu.contact'),
                        isVisible: true,
                    },
                ]
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';
    .subdomain-topnav {
        @include breakpoint(laptop) {
            padding: 20px;
        }
        @include breakpoint(smartphone-large) {
            padding: 15px;
        }
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 25px 0;
        &__item {
            display: flex;
            justify-content: space-between;

            &--info {
                @include breakpoint(laptop) {
                    height: 50px;
                }
                cursor: pointer;
                height: 60px;
                display: flex;
                align-items: center;

                img {
                    margin-right: 15px;
                }

                p {
                    color: $color-gray-3;
                }
            }

            &--routes {
                display: flex;

                .subdomain-main-menu__item {
                    a {
                        margin: 0 10px;
                        border-radius: 6px;
                        color: $subdomain-black1;
                        height: auto;
                        text-transform: uppercase;
                        font-weight: 500;
                        padding: 5px 20px;
                    }

                    &--is-current {
                        a {
                            border-radius: 6px;
                            color: $subdomain-black1;
                            font-weight: 800;
                        }
                    }
                }
            }
        }
    }

    .subdomain-layout--navy_black,
    .subdomain-layout--black {
        .subdomain-topnav {
            &__item {
                &--info {
                    p {
                        color: $subdomain-light2;
                    }
                }

                &--routes {
                    .subdomain-main-menu__item {
                        a {
                            color: $subdomain-very-light;
                        }
                    }
                }
            }
        }
    }

    .subdomain-layout--navy_black {
        .subdomain-topnav {
            &__item {
                &--routes {
                    .subdomain-main-menu__item {
                        &--is-current {
                            a {
                                color: $subdomain-blue;
                            }
                        }
                    }
                }
            }
        }
    }

    .subdomain-layout--black {
        .subdomain-topnav {
            &__item {
                &--info {
                    p {
                        color: $subdomain-light2;
                    }
                }

                &--routes {
                    .subdomain-main-menu__item {
                        a {
                            color: $subdomain-very-light;
                        }

                        &--is-current {
                            a {
                                color: $color-white;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
